import React from 'react';
import PropTypes from 'prop-types';
import * as ErrorMessage from '../../../constants/common/ErrorMessage';

/**
 * Header
 */
class Header extends React.Component {

  render() {
    let errorstyle = null;
    let comments;
    const iconStyle = {
      width: '51px'
    };

    if (this.props.error != null) {
      errorstyle = {
        background: '#fc765d'
      };

      const getCode = this.props.error.message;

      const errormessage = ErrorMessage.ERROR_MESSAGE.filter((item) => {
        return (item.code == getCode);
      });

      comments = <p id="header_error">{errormessage[0].message}</p>;
    }

    if ($('#header_error_used_machine_price_wrap').is(':visible')) {
      $('#header_error_used_machine_price_wrap').hide();
    }

    return (
      <header>
        {/* ---#headerWrap- */}
        <div id="headerWrap" className="clearfix" style={errorstyle}>
          <a href="/" title="ホーム"><img src="/img/header_logo01.png" alt="VECTERA クラウドサービス" height={51} /></a>
          <p id="header_error_used_machine_price_wrap">
            <p id="header_error_used_machine_price">コピーできません</p>
          </p>
          {comments}
          <ul className="buttpn-list clearfix">
            <li><a href="/" title="ホーム"><img src="/img/icon/fab_ホームボタン_共通.svg" alt="Home" style={iconStyle} /></a></li>
            <li><a href={PORTAL_URL} title="ポータル"><img src="/img/icon/fab_ポータルボタン_共通.svg" alt="Portal" style={iconStyle} /></a></li>
            <li>
              <a href="#" title="ログアウト" onClick={() => this.props.comactions.logout()}>
                <img src="/img/icon/fab_ログアウトボタン_共通.svg" alt="Logout" style={iconStyle} />
              </a>
            </li>
          </ul>
          <div className="name-box">
            <p>ユーザー名：<span className="user-name">{this.props.userName}</span></p>
          </div>
        </div>{/* ---//#headerWrap-*/}
      </header>
    );
  }
}

Header.propTypes = {
  userName: PropTypes.string.isRequired,
  comactions: PropTypes.any.isRequired,
};

export default Header;
